import { connect } from "react-redux";
import { createFeedback } from "../../../../action/common/commonActionCreator";
import { ISendToMail } from "../../../../models/common/INavbar";
import { useEffect, useState } from "react";
import { getAlertData } from "../../../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { ISendMail } from "../../../../models/common/IUserProfile";
import { getAllContactMail } from "../../../../action/student/studentHelpMailActionCreator";
import { MultiSelect } from "primereact/multiselect";
import { baseURL } from "../../../../constants/commonConstants";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { mailValidation } from "../../../../common-functions/commonFunctions";

const StudentSendToMail = (props: ISendToMail) => {
  const { SendMail, getAllMails, allMails, user } = props;

  const [content, setContent] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [toMailIds, setToMailIds] = useState<string[]>([])
  const navigate = useNavigate();

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }

    if (alertData.type === "success") {
      setSubject("");
      setContent("");
      setToMailIds([]);
    }
  };

  useEffect(() => {
    getAllMails();
  }, [])

  const handleSendMail = () => {
    
    let alertData = mailValidation(subject,content,toMailIds)
        if (alertData) {
          setShowAlert(true);
          setAlertType(alertData.type);
          setAlertTitle(alertData.title);
          return
      }
    
    const mailData: ISendMail = {
      toEmail: toMailIds.map((id) => id.split("-")[1]),
      subject: subject,
      content: content,
    };
    SendMail(mailData, setAlert);
  };

  const onConfirm = () => {
    setShowAlert(false);
  };

  const onCancel = () => {
    setSubject("");
    setContent("");
    navigate(ROUTER_URL.STUDENT_DASHBOAD);
  }

  return (
    <div className="feedbackwrap">
      <div className="card">
        <h2>Compose</h2>
        <p>
          Summarize your query briefly and send it to the chosen recipient. You
          can expect a reply within 24 hours.
        </p>

        <div className="emailform mt-3">
          <div className="label-to">
            <label htmlFor="">From</label>
            <div className="stude-details">
              <div className="img">
                <img src={user?.image ? baseURL + user.image : ""} alt="" onError={(e) => { e.currentTarget.src = "/assets/images/icon/DefaultImage.jpeg" }} />
              </div>
              <div className="desc">
                <h6>{user?.displayName}</h6>
                <p>
                  {user?.currentDepartment?.name} | <span>{user?.currentCollege?.name}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="multiselect-plugin label-to">
            <label htmlFor="">To</label>
            <div id="htmlselect" className="pt-1 to-email-box">
              <MultiSelect
                style={{
                  border: "none",
                  outline: "none",
                }}
                placeholder={`Choose Contact`}
                value={toMailIds}
                name="mailSelect"
                options={allMails?.map((emailData) => ({
                  label: emailData.name,
                  value: `${emailData.name}-${emailData.email}`,
                })) || []}
                onChange={(event) => {
                  setToMailIds(event.value);
                }}
                filter
                filterBy="label"
              />
            </div>
          </div>
          <div className="formgroup">
            <label htmlFor="">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="formgroup">
            <label htmlFor="">Message</label>
            <textarea
              name=""
              id="message"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            ></textarea>
          </div>
        </div>

        <div className="btn-flex mt-3">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSendMail}
          >
            Send
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
    </div>
  );
};

const mapDispatchToProps = {
  SendMail: (Feedback: ISendMail, callback: Function) =>
    createFeedback(Feedback, callback),
  getAllMails: () => getAllContactMail()
};

function mapStateToProps(state: any) {
  return {
    allMails: state.common.helpMail,
    user: state.userDetails.userProfileData
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentSendToMail);
